/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var XCircleIcon64Regular = forwardRef('XCircleIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M22.576 20.455a1.5 1.5 0 1 0-2.121 2.121L29.879 32l-9.424 9.424a1.5 1.5 0 1 0 2.121 2.121L32 34.121l9.424 9.424a1.5 1.5 0 1 0 2.121-2.121L34.121 32l9.424-9.424a1.5 1.5 0 1 0-2.121-2.121L32 29.879l-9.424-9.424Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M32 6C17.64 6 6 17.64 6 32s11.64 26 26 26 26-11.64 26-26S46.36 6 32 6ZM9 32C9 19.297 19.297 9 32 9s23 10.297 23 23-10.297 23-23 23S9 44.703 9 32Z" })));
});
